import SectionExploreDestinations from './SectionExploreDestinations';

export default SectionExploreDestinations;
